// import fetch from 'isomorphic-fetch';

import { createReducer } from '../utils';

const initialState = {
  developmentId: process.env.REACT_APP_DEVELOPMENT,
  organisationId: process.env.REACT_APP_ORGANISATION,
};


export default createReducer(initialState, {});



// WEBPACK FOOTER //
// ./src/redux/config.js